import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"mpos_card",
    list_id:"pos_card_list",
    x_column_list_arr:[
      {"key":"a_trade_date","name":"거래일","width":"100","is_show":"1"},
      {"key":"a_amount","name":"수량","width":"100","is_show":"1"},
      {"key":"a_tax_money","name":"세금","width":"110","is_show":"1"},
      {"key":"a_serve_money","name":"봉사료","width":"110","is_show":"1"},
      {"key":"a_pay_money","name":"결제금액","width":"110","is_show":"1"},
      {"key":"a_title","name":"수납명","width":"110","is_show":"1"},
      {"key":"a_approval_num","name":"승인번호","width":"110","is_show":"1"},
      {"key":"a_sort","name":"구분","width":"110","is_show":"1"},
      {"key":"a_card_num","name":"카드번호","width":"170","is_show":"1"},
      {"key":"a_card_company","name":"카드사","width":"120","is_show":"1"},
      {"key":"a_monthly_pay","name":"할부","width":"100","is_show":"1"},
      {"key":"a_memo","name":"메모","width":"100","is_show":"1"},
      {"key":"a_is_cancel","name":"취소여부","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':20,
      'order_id':'a_create_date DESC',
      'order_type':'',
      's_date_type':'a_trade_date',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;